import React from 'react';

interface SpaceEvent {
    id: string;
    title: string;
    date: Date;
    coHosts?: {
        name: string;
        avatar: string;
        handle: string;
    }[];
    spaceLink?: string;
}

interface SpacesCalendarProps {
    events: SpaceEvent[];
    className?: string;
}

const formatDate = (date: Date): string => {
    return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
};

export const SpacesCalendar: React.FC<SpacesCalendarProps> = ({
    events,
    className = '',
}) => {
    const upcomingEvents = events.filter(e => new Date(e.date) > new Date());

    if (upcomingEvents.length === 0) {
        return (
            <div className={`curator-spaces-empty ${className}`}>
                <p style={{ color: 'var(--text-muted)', textAlign: 'center' }}>
                    No upcoming Spaces scheduled. Check back soon!
                </p>
            </div>
        );
    }

    return (
        <div className={`curator-spaces ${className}`}>
            {upcomingEvents.map((event) => (
                <a
                    key={event.id}
                    href={event.spaceLink || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="curator-space-card"
                >
                    <div className="curator-space-date">
                        {formatDate(new Date(event.date))}
                    </div>

                    <div className="curator-space-title">{event.title}</div>

                    {event.coHosts && event.coHosts.length > 0 && (
                        <div className="curator-space-hosts">
                            {event.coHosts.map((host, i) => (
                                <img
                                    key={i}
                                    src={host.avatar}
                                    alt={host.name}
                                    title={`@${host.handle}`}
                                    className="curator-space-host"
                                />
                            ))}
                        </div>
                    )}
                </a>
            ))}
        </div>
    );
};

export default SpacesCalendar;
